
import { motion } from "framer-motion";
const animationConfiguration = {
    initial: { opacity: 0, x: 100 }, // Start the page 100 units to the right (you can adjust this value)
    animate: { opacity: 1, x: 0 }, // Move the page to the original position (x: 0) while fading in
    exit: { opacity: 0, x: -100 }, 
};
const Transitions = ({ children }) => {
    return (
        <motion.div
            variants={animationConfiguration}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.5 }}
        >
            {children}
        </motion.div>
    );
};
export default Transitions;